import { c as _c } from "react/compiler-runtime";
import type { AdItem } from '@sbt-web/network/types';
import { useLiraLazyOverlayGalleryForPrivate } from './useLiraLazyOverlayGalleryForPrivate';
import { useLiraLazyOverlayGalleryForPro } from './useLiraLazyOverlayGalleryForPro';
export const useLiraLazyOverlayGallery = t0 => {
  const $ = _c(6);
  const {
    ad,
    isMobile
  } = t0;
  let t1;
  if ($[0] !== ad || $[1] !== isMobile) {
    t1 = {
      ad,
      isMobile
    };
    $[0] = ad;
    $[1] = isMobile;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  useLiraLazyOverlayGalleryForPro(t1);
  const t2 = !isMobile;
  let t3;
  if ($[3] !== ad || $[4] !== t2) {
    t3 = {
      ad,
      isDesktop: t2
    };
    $[3] = ad;
    $[4] = t2;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  useLiraLazyOverlayGalleryForPrivate(t3);
};